RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Loading = Marionette.ItemView.extend({
        template: '#shellLoadingTemplate',
        className: function () {

            const me = this;
            const classNames = ['fade'];

            if (me.getOption('visible')) {
                classNames.push('in');
            }

            if (me.getOption('block')) {
                return classNames.concat('block-loading').join(' ');
            }

            if (me.getOption('page')) {
                classNames.push('full-page');
            }

            return classNames.concat('application-loading').join(' ');
        },
        onShow: function () {

            const me = this;

            _.defer(function () {
                me.$el.addClass('in');
            });
        },

        showForView: function () {
            const me = this;
            me.onShow();
        },

        hideForView: function (view) {
            const me = this;

            me.$el.removeClass('in');
            me.$el.addClass('hide');
            view.$el.removeClass('hide');
        }
    });

    const BLOCK_LOADING_MIN_HEIGHT = 100;
    // So huge tables dont create huge loading views
    const BLOCK_LOADING_MAX_HEIGHT = 400;

    views.BlockLoading = views.Loading.extend({
        template: '#shellPanelMinimalLoadingTemplate',
        className: 'panel-loading in',
        attributes: {
            style: `height: ${BLOCK_LOADING_MIN_HEIGHT}px;`
        },

        showForView: function (view) {
            const me = this;

            // Set loading view to the same height as the content it is
            // replacing
            const height = view.$el.outerHeight(true);
            view.$el.addClass('hide');
            if (height > BLOCK_LOADING_MIN_HEIGHT) {
                me.el.style.height = `${Math.min(BLOCK_LOADING_MAX_HEIGHT, height)}px`;
            }
            me.$el.removeClass('hide');
            me.$el.addClass('in');
        }
    });
});
